import React from 'react';
import { Grid, makeStyles, Slider, Typography } from '@material-ui/core';
import Tooltip from 'components/ExplanationHover';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import i18n from 'i18n';
import styles, { overrideExplanationHover } from './styles';

interface Props {
  value: number;
  label: string;
  overrideClasses?: any;
  tooltip?: string;
  setFieldValue?: (field: string, value: any) => void;
}

const SliderComponent = ({
  value,
  label,
  stateKey,
  overrideClasses,
  tooltip,
  setFieldValue,
}: GenericFormItem & Props) => {
  const useStyles = makeStyles(styles(overrideClasses));
  const classes = useStyles();
  const [sliderValue, setSliderValue] = React.useState<number | number[]>(0);

  React.useEffect(() => {
    setSliderValue(value);
  }, [value]);

  const handleSliderChange = (
    event: React.ChangeEvent<{}>,
    value: number | number[]
  ) => {
    if (setFieldValue) {
      setFieldValue(stateKey, value || 0);
    }
    setSliderValue(value);
  };

  return (
    <Grid xs={4} className={classes.container}>
      <Grid container alignItems="center">
        <Typography variant="subtitle2" color="textSecondary">
          {label}
        </Typography>
        {tooltip && (
          <Tooltip
            overrideClasses={overrideExplanationHover}
            title={i18n.t(`${tooltip}`)}
          />
        )}
      </Grid>
      <Slider
        value={sliderValue}
        aria-label="Small"
        valueLabelDisplay="auto"
        onChange={handleSliderChange}
      />
    </Grid>
  );
};

export default SliderComponent;
